import "./App.css";
import Appbar from "./componenets/AppBar";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import "react-toastify/dist/ReactToastify.css";
import "../node_modules/antd/dist/reset.css";
import "../node_modules/antd/dist/antd.js";

import { Route, Routes } from "react-router-dom";
import { PUBLIC_ROUTES } from "./routes";

function App() {
  return (
    <>
      <Appbar />
      <Routes>
        {PUBLIC_ROUTES?.map((routes) => (
          <Route path={routes.path} element={routes.element} key={routes.id} />
        ))}
      </Routes>
    </>
  );
}

export default App;
